import React from "react";
import { Link } from "react-router-dom";
import { aboutImages, happenings, menuHighlights } from "../data/mock";

const tiles = [
  {
    label: "Menu",
    caption: "Flavours that hold the moment",
    href: "#menu",
    image: menuHighlights[0]?.image,
  },
  {
    label: "Reservations",
    caption: "Ways to gather around the table",
    href: "#reservation",
    image: aboutImages.spread,
  },
  {
    label: "Catering",
    caption: "Feasts carried beyond our walls",
    href: "#catering",
    image: happenings[1]?.image || aboutImages.chef,
  },
  {
    label: "Stories",
    caption: "Where the kitchen keeps its memory",
    href: "/blog",
    image: aboutImages.chef,
  },
];

function Tile({ t }) {
  const inner = (
    <>
      <div className="img-hover">
        <div className="aspect-[3/4] overflow-hidden">
          <img src={t.image} alt={t.label} loading="lazy" className="w-full h-full object-cover" />
        </div>
      </div>
      <h3 className="font-display text-2xl md:text-3xl text-[var(--mm-cream)] mt-6 leading-tight">
        {t.label}
      </h3>
      <p className="text-sm text-[var(--mm-cream-muted)] font-light mt-2 leading-relaxed">
        {t.caption}
      </p>
      <span className="editorial-link mt-4">explore more</span>
    </>
  );
  const testId = `explore-tile-${t.label.toLowerCase()}`;
  if (t.href.startsWith("/")) {
    return (
      <Link to={t.href} className="block group" data-testid={testId}>
        {inner}
      </Link>
    );
  }
  return (
    <a href={t.href} className="block group" data-testid={testId}>
      {inner}
    </a>
  );
}

export default function ExploreTiles() {
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="mb-14 fade-in">
          <div className="section-label mb-4">Ways to gather</div>
          <h2 className="font-display text-4xl md:text-6xl text-[var(--mm-cream)] leading-none">
            Beyond the plate
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14 fade-in">
          {tiles.map((t) => (
            <Tile key={t.label} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
